import * as S from "./ResultCardList.style";
import { ResultCardItem } from "@/components/atoms/ResultCardItem";

interface ResultCardListProps {
  data?: any;
  name?: string;
  handleRadioClick?: (isChecked: boolean) => void;
}

export const ResultCardList = ({
  data,
  name,
  handleRadioClick,
}: ResultCardListProps) => {
  return (
    <>
      <S.ResultCardList>
        {data && (
          <ResultCardItem
            data={data}
            name={name}
            handleRadioClick={handleRadioClick}
          />
        )}
      </S.ResultCardList>
    </>
  );
};
